// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__FkhsP","buttons":"PendingPaymentAlert_buttons__l-4-V"};